import { useTranslation } from "react-i18next";

import i18n from "i18next";

import { IconSprite } from "../../../../../../ui/IconSprite/IconSprite";

import { Link } from "./AnonymizerLink.styled";

const AnonymizerLink = () => {
  const { t } = useTranslation();
  const lang = i18n.language;

  const navigatePath = lang === "en" ? "/" : `/${lang}/`;

  return (
    <Link to={navigatePath}>
      <IconSprite tag="anonymizerIcon" width="24" height="24" />
      <p>{t("header.mainBtn")}</p>
    </Link>
  );
};

export default AnonymizerLink;
